import IApplicationState from 'app/types/state';
import _ from 'lodash';
import { getOrganisationConnectionCode } from 'app/ducks/organisations/selectors';

export const getShareUrl = (state) => {
  if (_.isEmpty(state.onBoarding.inFlightUser.team)) {
    return '';
  }
  const token = state.onBoarding.inFlightUser.team.inviteToken;
  return `${JOIN_URL}/${token}`;
};

export function getOnBoarding(state: IApplicationState): any {
  return {
    ...state.onBoarding,
    currentOrganisation: getOrganisationConnectionCode(
      state,
      state.onBoarding.inFlightUser.orgConnectionCode,
    ),
  };
}

export function parseCognitoErrorMessage(code: string, fallbackMessage: string): string {
  let returnMessage: string;
  switch (code) {
    case 'InvalidParameterException':
      if (fallbackMessage = 'User is already confirmed') {
        returnMessage = 'This email already has an account, please try logging in.';
      } else {
        returnMessage = fallbackMessage;
      }
      break;
    default:
      returnMessage = fallbackMessage;
      break;
  }
  return returnMessage;
}
